import { Component, Input, OnInit } from '@angular/core';
import { PromotionDetail } from '../../models/promotions';
import { CARD_LAYOUT } from '@myclubrewards/shared';

@Component({
  selector: 'myclubrewards-promotion-primary',
  templateUrl: './promotion-primary.component.html',
  styleUrls: ['./promotion-primary.component.scss'],
})
export class PromotionPrimaryComponent implements OnInit {
  private _primaryPromotion: any;

  @Input('promotion') set promotion(value: PromotionDetail) {
    this._primaryPromotion = {
      ...value,
      layout: CARD_LAYOUT.EXPANSION_LAYOUT,
    };
  }

  constructor() {}

  ngOnInit(): void {}

  get promotion() {
    return this._primaryPromotion;
  }
}
